module.exports = __webpack_public_path__ + "static/media/business.0709ef5a.svg";